export function removeEditableUser(context) {
  context.stores.userEditor.remove();
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/users/lib/remove_editable_user.js